import { render, staticRenderFns } from "./CardBack.vue?vue&type=template&id=66dada63&scoped=true&"
import script from "./CardBack.vue?vue&type=script&lang=js&"
export * from "./CardBack.vue?vue&type=script&lang=js&"
import style0 from "./CardBack.vue?vue&type=style&index=0&id=66dada63&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dada63",
  null
  
)

export default component.exports